import { useMemo } from "react"

import { DEFAULT_FUZZY_SEARCH_OPTIONS } from "shared/constants/search"
import { useFuzzySearchWithRanges } from "shared/lib/useFuzzySearchWithRanges"
import { Project } from "shared/types/Project"

import { useProjects } from "entities/projects/api/useProjects"

import { ProjectSearchResult } from "../types/GlobalSearch"

interface UseProjectSearchProps {
  searchTerm?: string | null
}

function getProjectTitle(project: Project) {
  return project.title
}

export function useProjectSearch({ searchTerm }: UseProjectSearchProps): {
  results: ProjectSearchResult[]
  isLoading: boolean
} {
  const { projects, loading } = useProjects()
  const canSearch = (searchTerm?.length ?? 0) >= 2

  const fuzzySearch = useFuzzySearchWithRanges<Project>({
    getSearchableString: getProjectTitle,
    options: DEFAULT_FUZZY_SEARCH_OPTIONS
  })

  const results = useMemo<ProjectSearchResult[]>(() => {
    const fuzzySearchResults = canSearch
      ? fuzzySearch(projects, searchTerm)
      : []

    return fuzzySearchResults.map(fuzzySearchResult => ({
      project: fuzzySearchResult.item,
      matchInfo: { title: { ranges: fuzzySearchResult.ranges } }
    }))
  }, [projects, searchTerm])

  return { results, isLoading: canSearch && loading }
}
